<div class="m-15 wrapper" style="position: relative">
  <div
    class="not-pro-message-wrapper"
    *ngIf="data != null && data.tier != null && data.tier != 'pro'"
  >
    <div class="not-pro-icon">
      <svg
        width="100"
        height="100"
        viewBox="0 0 100 100"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clip-path="url(#clip0)">
          <path
            d="M78.625 37.5H75.5V25C75.5 11.2125 64.2875 0 50.5 0C36.7125 0 25.5 11.2125 25.5 25V37.5H22.375C17.2083 37.5 13 41.7042 13 46.875V90.625C13 95.7958 17.2083 100 22.375 100H78.625C83.7917 100 88 95.7958 88 90.625V46.875C88 41.7042 83.7917 37.5 78.625 37.5ZM33.8333 25C33.8333 15.8083 41.3083 8.33333 50.5 8.33333C59.6917 8.33333 67.1667 15.8083 67.1667 25V37.5H33.8333V25ZM54.6667 69.675V79.1667C54.6667 81.4667 52.8042 83.3333 50.5 83.3333C48.1958 83.3333 46.3333 81.4667 46.3333 79.1667V69.675C43.8542 68.2292 42.1667 65.5708 42.1667 62.5C42.1667 57.9042 45.9042 54.1667 50.5 54.1667C55.0958 54.1667 58.8333 57.9042 58.8333 62.5C58.8333 65.5708 57.1458 68.2292 54.6667 69.675Z"
            fill="#C7700A"
          />
        </g>
      </svg>
    </div>
  </div>

  <div class="filters-wrapper justify-content-between align-items-center px-4">
    <div class="d-flex align-items-center">
      <!-- FILTER BY PINNED FOR -->
      <div class="dropdown-timetracking" tooltip="Pinned For">
        <span dropdown [autoClose]="true">
          <div dropdownToggle>
            <i class="tio-pinned_by"></i>
            For:
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName].assignedToFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a class="dropdown-item" (click)="changeAssignedToFilter('me')"
                >Me</a
              >
            </li>
            <ng-container
              *ngIf="[ROLE_MANAGER, ROLE_ADMIN].includes(userPermissions?.role)"
            >
              <li role="menuitem">
                <a
                  class="dropdown-item"
                  (click)="changeAssignedToFilter('everyone')"
                  >Everyone</a
                >
              </li>
              <hr />
              <li
                role="menuitem"
                *ngFor="let accountant of jobsStore.company.accountants"
                (click)="
                  changeAssignedToFilter({
                    id: accountant.user.id,
                    name: accountant.user.full_name,
                  })
                "
              >
                <a class="dropdown-item">{{ accountant.user.full_name }}</a>
              </li>
            </ng-container>
          </ul>
        </span>
      </div>

      <!-- FILTER BY PINNED BY -->
      <div class="dropdown-timetracking" tooltip="Pinned By">
        <span dropdown [autoClose]="true">
          <div dropdownToggle>
            <i class="tio-pinned_by"></i>
            By:
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName].personFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a class="dropdown-item" (click)="changePersonFilter('me')">Me</a>
            </li>
            <li role="menuitem">
              <a class="dropdown-item" (click)="changePersonFilter('everyone')"
                >Everyone</a
              >
            </li>
          </ul>
        </span>
      </div>

      <!-- FILTER BY TIME FRAME-->
      <div class="dropdown-timetracking">
        <span dropdown #dropdown="bs-dropdown">
          <div dropdownToggle>
            <i class="feather calendar"></i>
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName].timeFrameFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            style="min-width: 280px; overflow: visible"
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeFrameFilter(null); dropdown.hide()"
                >All</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeFrameFilter('today'); dropdown.hide()"
                >Today</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeFrameFilter('this_week'); dropdown.hide()"
                >This week</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeFrameFilter('last_week'); dropdown.hide()"
                >Last week</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="
                  changeTimeFrameFilter('last_two_weeks'); dropdown.hide()
                "
                >Last two weeks</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="
                  changeTimeFrameFilter('last_four_weeks'); dropdown.hide()
                "
                >Last four weeks</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changeTimeFrameFilter('last_month'); dropdown.hide()"
                >Last month</a
              >
            </li>
            <hr />
            <li>
              <p-datepicker
                #calendar
                selectionMode="range"
                placeholder="Select custom date range"
                dateFormat="yy.mm.dd"
                dataType="string"
                showClear="true"
                [(ngModel)]="date"
                (ngModelChange)="onDateChange() && dropdown?.hide()"
              ></p-datepicker>
            </li>
          </ul>
        </span>
      </div>

      <!-- FILTER BY STATUS -->
      <div class="dropdown-timetracking">
        <span dropdown [autoClose]="true">
          <div dropdownToggle>
            <i class="tio-pinned_bys"></i>
            <span class="sort-by">{{
              dashboardService.filters()[dashboardName].pinnedStatusFilter.label
            }}</span>
            <i class="feather chevron-down"></i>
          </div>
          <ul
            *dropdownMenu
            class="dropdown-menu"
            aria-labelledby="dLabel"
            role="menu"
          >
            <li role="menuitem">
              <a class="dropdown-item" (click)="changePinnedStatusFilter(null)"
                >All</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="changePinnedStatusFilter(PinnedStatus.Pinned)"
                >To-do</a
              >
            </li>
            <li role="menuitem">
              <a
                class="dropdown-item"
                (click)="
                  changePinnedStatusFilter(PinnedStatus['Pinned Complete'])
                "
                >Completed</a
              >
            </li>
          </ul>
        </span>
      </div>
    </div>

    <!-- Export -->
    <!-- <div
      class="btn-group export-button"
      dropdown
      [autoClose]="true"
      placement="bottom right"
    >
      <button
        id="button-basic"
        dropdownToggle
        type="button"
        class="btn btn-success dropdown-toggle"
        aria-controls="dropdown-basic"
      >
        Export <span class="caret"></span>
      </button>
      <ul
        id="dropdown-basic"
        *dropdownMenu
        class="dropdown-menu dropdown-menu-right"
        role="menu"
        aria-labelledby="button-basic"
        style="z-index: 999999"
      >
        <li class="p-button-success mr-2">
          <a class="dropdown-item" (click)="exportExcel()">
            <i class="feather table"></i>
            Export to .xls</a
          >
        </li>
        <li class="p-button-warning mr-2">
          <a class="dropdown-item" (click)="exportPdf()">
            <i class="feather table"></i>
            Export to .pdf</a
          >
        </li>
        <li class="p-button-success mr-2">
          <a class="dropdown-item" (click)="exportCsv()">
            <i class="feather table"></i>
            Export to .csv</a
          >
        </li>
      </ul>
    </div> -->
  </div>

  <p-table
    #table
    [rowHover]="true"
    [value]="pinnedItems"
    sortMode="single"
    [columns]="cols"
    [scrollable]="true"
    [rows]="dashboardService.filters()[this.dashboardName].rows || 25"
    (onPage)="onPageChange($event)"
    [lazy]="true"
    [totalRecords]="totalRecords"
    (onLazyLoad)="retrievePinneditems($event)"
    [paginator]="true"
    [rowsPerPageOptions]="[10, 25, 50, 100, 1000]"
    [loading]="loading"
    scrollHeight="calc(100vh - 245px)"
    rowGroupMode="subheader"
    groupRowsBy="client_company"
    styleClass="job-list"
    responsiveLayout="scroll"
    [resizableColumns]="true"
    [showCurrentPageReport]="true"
    columnResizeMode="fit"
    currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
  >
    <ng-template pTemplate="emptymessage" let-columns>
      <tr class="empty-row">
        <td [attr.colspan]="columns.length">
          <div class="empty-dashboard-row-content">
            <ds-empty-state
              icon="tio-pin"
              title="No Pinned Items to Display"
              description="Start by pinning items or check back later to see updates."
            ></ds-empty-state>
          </div>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="header" let-columns>
      <tr>
        <th style="min-width: 200px" *ngFor="let col of columns">
          {{ col.header }}
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="groupheader" let-pinnedItem>
      <tr style="background: #dee2e6 !important">
        <td colspan="1000" style="padding: 1px"></td>
      </tr>
      <tr
        pRowGroupHeader
        class="border-top-table-separator"
        style="top: 23px !important; background: #fff !important"
      >
        <td colspan="1000">
          <span class="font-bold ml-2">
            {{ getClientName(pinnedItem.client_company) }}
          </span>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-pinnedItem let-rowIndex="rowIndex">
      <tr>
        <td style="min-width: 200px">
          @if (pinnedItem.assigned_to) {
            <img
              class="avatar avatar24"
              [alt]=""
              [src]="pinnedItem.pinned_by.pictureUrl"
              style="
                vertical-align: middle;
                margin-right: 8px;
                width: 24px;
                height: 24px;
              "
            />
            {{ pinnedItem.assigned_to?.full_name }}
          }
        </td>
        <td style="min-width: 200px">
          <img
            class="avatar avatar24"
            [alt]=""
            [src]="pinnedItem.pinned_by.pictureUrl"
            style="
              vertical-align: middle;
              margin-right: 8px;
              width: 24px;
              height: 24px;
            "
          />
          {{ pinnedItem.pinned_by.full_name }}
        </td>
        <td style="min-width: 200px">
          <span>
            {{ pinnedItem.pinned_dt | amDateFormat: "MMM Do, YYYY" }}
          </span>
        </td>
        <td style="min-width: 200px">
          {{ PinnedItemType[pinnedItem.model_name] }}
        </td>
        <td style="min-width: 200px">
          <app-pinned-card
            [ngClass]="{ 'disable-hover': isPinnedItemNote(pinnedItem) }"
            [disableClick]="isPinnedItemNote(pinnedItem)"
            [pinnedItem]="pinnedItem"
            [clientCompanyId]="getClientCompanyId(pinnedItem.client_company)"
          ></app-pinned-card>
        </td>
        <td style="min-width: 200px">
          {{ PinnedStatus[pinnedItem.pinned_status] }}
        </td>
      </tr>
    </ng-template>
  </p-table>
</div>
